<ion-header>
  <ion-toolbar>
    <ion-title>Select date</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-datetime
    class="tw:h-full"
    presentation="date"
    size="cover"
    [value]="date"
    [min]="min"
    [max]="max"
    (ionChange)="onDateChange($event)"
  ></ion-datetime>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()"> <ion-icon slot="start" name="close-circle-outline"></ion-icon> Close </ion-button>
    </ion-buttons>
    <ion-buttons slot="primary">
      <ion-button class="tw:font-bold" (click)="select()">
        <ion-icon slot="end" name="checkmark-circle-outline"></ion-icon> Select
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
